import React from "react"
import { BoxWrapper } from "components"

const News = ({ boxWrapperProps }: INewsContainerProps) => {
  return <BoxWrapper {...boxWrapperProps}></BoxWrapper>
}

export default News
